import { useRef, useState } from 'react'
import { Menu } from '@mui/material'

import { SeeMoreIcon } from '@assets/svgs/SeeMoreIcon'
import { CloseIcon } from '@assets/svgs/CloseIcon'

import type { ActionsProps } from './types'

import * as S from './styles'

export const Actions = ({ actions, disabled }: ActionsProps) => {
  const userBoxRef = useRef<HTMLDivElement | null>(null)

  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false)

  return (
    <S.Container>
      <S.ActionIconBox onClick={() => !disabled && setIsUserMenuOpen(true)}>
        <S.ActionIcon ref={userBoxRef} disabled={!!disabled}>
          <SeeMoreIcon />
        </S.ActionIcon>
      </S.ActionIconBox>

      <Menu
        anchorEl={userBoxRef.current}
        open={isUserMenuOpen}
        onClose={() => setIsUserMenuOpen(false)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        slotProps={{
          paper: { component: S.MenuPaper },
          list: { component: S.MenuList }
        }}
      >
        <S.CloseIconBox>
          <S.CloseIcon onClick={() => setIsUserMenuOpen(false)}>
            <CloseIcon />
          </S.CloseIcon>
        </S.CloseIconBox>

        <S.MenuItemBox>
          {actions.map((item) => (
            <S.MenuItem
              key={item.label}
              disabled={!!item.disabled}
              onClick={() => {
                if (item.disabled) return
                item.onClick()
                setIsUserMenuOpen(false)
              }}
            >
              <S.Icon>{item.icon}</S.Icon>
              {item.label}
            </S.MenuItem>
          ))}
        </S.MenuItemBox>
      </Menu>
    </S.Container>
  )
}
